import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import LOOKUP from 'constants/lookup';
import DialogInput from 'screens/components/advanced/DialogInput';
import RadioInput from 'screens/components/basic/RadioInput';
import TextInput from 'screens/components/basic/TextInput';
import MinusAndPlusInput from 'screens/components/basic/MinusAndPlusInput';
import { MeasurementType, OrderProductStatus, RefundReason } from 'constants/enums';
import Button from 'screens/components/basic/Button';
import { formInput, formError, cleanRefundForm, clearFormInput } from 'actions/FormActions';
import { selectRefundProducts } from 'selectors/entitySelector';
import { addRefundOrder, giftCardRefund, paystoneGiftCardRefund, birchmountGiftCardRefund, checkOrderUpdateTime } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import util from 'library/util';
import GenericTable from 'screens/components/advanced/GenericTable';
import DialogHeader from 'screens/components/basic/DialogHeader';
import ToggleInput from 'screens/components/basic/ToggleInput';

const dialogStyle = {
    width: '100%',
    maxWidth: 'none'
};

class POSRefundDialog extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dialog: true,
            dialogConfirm: false
        };
    }

    componentWillReceiveProps = (newProps) => {
        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)
            || (newProps.saveError != undefined && newProps.saveError !== this.props.saveError)) {
            // if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess === true)
                this.saveSuccess();
            else if (newProps.saveSuccess === false && newProps.saveError) {
                const errorCode = newProps.saveError.split('-')[0];
                this.saveFailure(errorCode);
            }
        }

        if (this.props.open !== newProps.open && newProps.open === true && newProps.products) {
            newProps.products.filter((p) => p.isRefundable && p.status == 2).forEach((product) => {
                if ((product.measurementType !== MeasurementType.Unit)) {
                    this.props.formInput(product.quantity, this.props.name + "Quantity_" + product.id);
                }
            });
        }

        if (newProps.giftCardRefundReponse !== null && newProps.giftCardRefundReponse !== undefined && newProps.giftCardRefundReponse !== this.props.giftCardRefundReponse) {
            let model = newProps.model;
            const deviceData = JSON.parse(localStorage.getItem(newProps.deviceKeyName));
            model.DeviceId = deviceData.id;

            this.props.addRefund(newProps.order.id, model);
        }

        if (newProps.paystoneGiftCardRefundTime !== null && newProps.paystoneGiftCardRefundTime !== undefined && newProps.paystoneGiftCardRefundTime !== this.props.paystoneGiftCardRefundTime) {
            this.props.printPaystoneGiftCardReceipt(newProps.paystoneGiftCardRefundData);
            let model = newProps.model;
            const deviceData = JSON.parse(localStorage.getItem(newProps.deviceKeyName));
            model.DeviceId = deviceData.id;

            this.props.addRefund(newProps.order.id, model);
        }

        if (newProps.birchmountGiftCardRefundTime !== null && newProps.birchmountGiftCardRefundTime !== undefined && newProps.birchmountGiftCardRefundTime !== this.props.birchmountGiftCardRefundTime) {
            this.props.printBirchmountGiftCardReceipt(newProps.birchmountGiftCardRefundData.response);
            let model = newProps.model;
            const deviceData = JSON.parse(localStorage.getItem(newProps.deviceKeyName));
            model.DeviceId = deviceData.id;

            this.props.addRefund(newProps.order.id, model);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.posOrderCheckUpateTimeRefundPassed &&
            (this.props.posOrderCheckUpateTimeRefundPassed !== prevProps.posOrderCheckUpateTimeRefundPassed)) {
            this.applyRefund();
        }
    }

    componentWillUnmount() {
        this.props.clearFormInput(`POSRefundTotalAmount`);
    }

    saveSuccess = () => {
        this.onClose();
        this.props.showSnackbar(this.props.t('pos.applyRefundDialog.saveSuccessMessage'));
    }

    saveFailure = (errorCode) => {
        if (errorCode && errorCode == 9) {
            this.props.showError(this.props.t('pos.messages.invalidCredentialsRefund'));
        }
        if (errorCode && errorCode == 31) {
            this.props.showError(this.props.t('pos.messages.CannotRefundGiftCard'));
        }
        else {
            this.props.showError(this.props.t('pos.applyRefundDialog.saveErrorMessage'));
        }
    }

    onClose = () => {
        this.props.onClose();
        this.props.cleanForm(this.props.name);
    }

    openConfirm = () => {
        if (!this.props.returnMethod) {
            this.props.showError(this.props.t("pos.refundDialog.selectMethod"));
            return;
        }
        this.setState({ dialogConfirm: true });
        let productsModel = this.props.model.OrderProductsVM;
        let products = this.props.products;
        let productList = [];
        let refundAmount = 0;
        let cashInDrawer = this.props.cashInDrawer;

        if (productsModel && products) {
            products.forEach((product1) => {
                productsModel.forEach((product2) => {
                    if (product1.id === product2.OrderProductId) {
                        productList.push({
                            Product: product1.name,
                            Quantity: product2.Quantity,
                            Reason: (product2.RefundReason.toString() === RefundReason.Defective.toString()) ? "Defective" : "Unopened"
                        });
                        refundAmount += (product1.pricePerUnitIncludeTax - (product1.discountValue / product1.quantity)) * product2.Quantity;
                    }
                });
            });
        }

        // if shipping cost is also refunded, we need to change the refund amount to include the shipping cost
        if (this.props.refundShipping && this.props.order && this.props.order.shippingCost > 0) {
            refundAmount += this.props.order.shippingCost;
        }

        if (refundAmount > 0) {
            this.props.formInput(refundAmount.toFixed(2), `POSRefundTotalAmount`);
        }

        if (refundAmount > cashInDrawer && this.props.returnMethod == 7) {
            this.props.showError(this.props.t('pos.refundDialog.insufficientCash'));
        }
    }

    closeConfirm = () => {
        this.setState({ dialogConfirm: false });
    }


    applyRefund = () => {
        let model = this.props.model;
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        model.DeviceId = deviceData.id;

        const p = this.props;

        if (model.orderId !== 0) {
            let validators = [];
            // do validate the input when the refund by manager is enabled, otherwise don't do any check
            if (!this.props.pinCode && p.refundNeedManagerApproval) {
                validators = [
                    [p.name + 'Username', d => (d.UserName && d.UserName !== ""), "Username"],
                    [p.name + 'Password', d => (d.Password && d.Password !== ""), "Password"]
                ];
            }

            if (util.validate(validators, model, this.props.formError)) {
                model.OrderProductsVM = model.OrderProductsVM.filter(item => item.OrderProductId && (item.Quantity && item.Quantity > 0) && item.RefundReason);
                if ((model.OrderProductsVM && model.OrderProductsVM.length > 0) || p.refundShipping) {
                    // refund by credit card
                    if (this.props.returnMethod == OrderProductStatus.ReturnedCreditCard && (this.props.monerisEnabled || this.props.picEnabled || this.props.payFirmaEnabled || this.props.paystoneInStoreEnabled || this.props.store.picPoyntInStoreEnabled || this.props.store.paymentreeInStoreEnabled || this.props.store.globalInStorePaymentEnabled || this.props.store.adyenInStorePaymentEnabled)) {
                        let orderCreditPayment = this.props.order.payments.filter(x => x.name == "Credit")[0];
                        if (this.props.monerisEnabled) {
                            this.props.cardRefund(orderCreditPayment.cardOrderId, orderCreditPayment.cardTxnNumber, this.props.refundAmount);
                        } else if (this.props.picEnabled) {
                            this.props.formInput(null, 'picStatus');
                            this.props.picRefund(orderCreditPayment.cardOrderId, this.props.refundAmount);
                        } else if (this.props.payFirmaEnabled) {
                            this.props.payFirmaRefund(orderCreditPayment.cardOrderId, this.props.refundAmount);
                        } else if (this.props.paystoneInStoreEnabled) {
                            this.props.paystoneRefund(orderCreditPayment.cardOrderId, this.props.refundAmount);
                        } else if (this.props.store.picPoyntInStoreEnabled) {
                            this.props.picPoyntRefund(orderCreditPayment.cardOrderId, this.props.refundAmount);
                        } else if (this.props.store.paymentreeInStoreEnabled) {
                            this.props.paymentreeRefund(orderCreditPayment.cardOrderId, this.props.refundAmount);
                        } else if (this.props.store.globalInStorePaymentEnabled) {
                            this.props.globalRefund(orderCreditPayment.cardOrderId, this.props.refundAmount);
                        } else if (this.props.store.adyenInStorePaymentEnabled) {
                            this.props.adyenRefund(orderCreditPayment.cardOrderId, orderCreditPayment.cardTxnNumber, this.props.refundAmount);
                        }
                    }
                    // refund by debit card
                    else if (this.props.returnMethod == OrderProductStatus.ReturnedDebitCard && (this.props.monerisEnabled || this.props.picEnabled || this.props.payFirmaEnabled || this.props.paystoneInStoreEnabled || this.props.store.picPoyntInStoreEnabled || this.props.store.paymentreeInStoreEnabled || this.props.store.globalInStorePaymentEnabled || this.props.store.adyenInStorePaymentEnabled)) {
                        let orderDebitPayment = this.props.order.payments.filter(x => x.name == "Debit")[0];
                        if (this.props.monerisEnabled) {
                            this.props.cardRefund(orderDebitPayment.cardOrderId, orderDebitPayment.cardTxnNumber, this.props.refundAmount);
                        } else if (this.props.picEnabled) {
                            this.props.formInput(null, 'picStatus');
                            this.props.picRefund(orderDebitPayment.cardOrderId, this.props.refundAmount);
                        } else if (this.props.payFirmaEnabled) {
                            this.props.payFirmaRefund(orderDebitPayment.cardOrderId, this.props.refundAmount);
                        } else if (this.props.store.picPoyntInStoreEnabled) {
                            this.props.picPoyntRefund(orderDebitPayment.cardOrderId, this.props.refundAmount);
                        } else if (this.props.paystoneInStoreEnabled) {
                            this.props.paystoneRefund(orderDebitPayment.cardOrderId, this.props.refundAmount);
                        } else if (this.props.store.paymentreeInStoreEnabled) {
                            this.props.paymentreeRefund(orderDebitPayment.cardOrderId, this.props.refundAmount);
                        } else if (this.props.store.globalInStorePaymentEnabled) {
                            this.props.globalRefund(orderDebitPayment.cardOrderId, this.props.refundAmount);
                        } else if (this.props.store.adyenInStorePaymentEnabled) {
                            this.props.adyenRefund(orderDebitPayment.cardOrderId, orderDebitPayment.cardTxnNumber, this.props.refundAmount);
                        }
                    }
                    // refeund by gift card
                    else if (this.props.returnMethod == OrderProductStatus.ReturnedGiftCard) {
                        let orderGiftCardPayment = this.props.order.payments.filter(x => x.name == "GiftCard")[0];
                        if (this.props.monerisGiftCardEnabled) {
                            let model = {
                                OrderId: orderGiftCardPayment.cardOrderId,
                                TxnNumber: orderGiftCardPayment.cardTxnNumber,
                                BranchId: this.props.branchId,
                                CvdValue: this.props.cvdValue
                            }
                            this.props.giftCardRefund(model);
                        } else if (this.props.paystoneGiftCardEnabled) {
                            let p = this.props;
                            let model = {
                                BranchId: p.branchId,
                                CardNumber: p.paystoneCardNumber,
                                PayStoneOperations: LOOKUP.PayStoneGiftCardOperationType.Cancel,
                                WAN: p.cashFlow.employee.id,
                                WSN: p.cashFlow.deviceId,
                                Amount: this.props.refundAmount,
                                InvoiceNumber: orderGiftCardPayment.cardOrderId,
                                TCR: orderGiftCardPayment.cardTxnNumber
                            };
                            this.props.paystoneGiftCardRefund(model);
                        } else if (this.props.birchmountGiftCardEnabled) {
                            let p = this.props;
                            let model = {
                                BranchId: p.branchId,
                                Operations: LOOKUP.BirchmountGiftCardOperationType.Refund,
                                TransId: orderGiftCardPayment.cardTxnNumber,
                                CardNumber: p.birchmountCardNumber,
                                Amount: this.props.refundAmount,
                            };
                            this.props.birchmountGiftCardRefund(model);
                        }
                        else {
                            this.props.addRefund(this.props.order.id, model);
                        }
                    } else {
                        this.props.addRefund(this.props.order.id, model);
                    }

                    this.closeConfirm();
                } else {
                    this.props.showError(this.props.t('pos.refundDialog.fillOutProductsForRefund'));
                }
            }
        }
    }

    getProducts = () => {
        const products = this.props.products;

        return products.filter((p) => p.isRefundable && p.status === OrderProductStatus.Completed && p.qtyAvaibleForRefund > 0).map((product) => {
            return {
                Product: product.name + (product.packageReference ? ` (${this.props.t('pos.page.lotNum')}: ${product.packageReference})` : ""),
                Quantity: (product.measurementType === MeasurementType.Unit)
                    ? <MinusAndPlusInput name={`${this.props.name}Quantity_${product.id}`} minimum="0" maximum={product.qtyAvaibleForRefund} />
                    : (<TextInput name={`${this.props.name}Quantity_${product.id}`} fullWidth={true} disabled={true} style={{ display: "none" }} />, product.qtyAvaibleForRefund),
                Reason:
                    <div>
                        <RadioInput
                            groupName={`${this.props.name}RefundReason_${product.id}`}
                            options={[{ text: this.props.t('pos.refundDialog.defective'), value: RefundReason.Defective.toString() }, { text: this.props.t('pos.refundDialog.unopened'), value: RefundReason.Unopened.toString() }]}
                            defaultValue=""
                        />
                    </div>
            };
        });
    }

    getConfirmationProduct = () => {
        let productsModel = this.props.model.OrderProductsVM;
        let products = this.props.products;
        let productList = [];

        if (productsModel && products) {
            products.forEach((product1) => {
                productsModel.forEach((product2) => {
                    if (product1.id === product2.OrderProductId) {
                        productList.push({
                            Product: product1.name,
                            Quantity: product2.Quantity,
                            Reason: (product2.RefundReason.toString() === RefundReason.Defective.toString()) ? "Defective" : "Unopened"
                        });
                    }
                });
            });
        }

        return productList;
    }

    checkOrderUpdateTime = () => {
        this.props.checkOrderUpdateTime(this.props.order.id, this.props.order.modifiedDate, "refund")
    }

    render() {
        const { t } = this.props; 
        const p = this.props;
        const refundMethods = [];

        if (p.order && p.order.payments) {
            refundMethods.push({ text: t('pos.refundDialog.cash'), value: OrderProductStatus.ReturnedCash.toString() });
            if (p.order.payments.filter(x => x.name === "Credit").length > 0) {
                refundMethods.push({ text: t('pos.refundDialog.creditOrDebit'), value: OrderProductStatus.ReturnedCreditCard.toString() });
            }
            if (p.order.payments.filter(x => x.name === "Debit").length > 0) {
                refundMethods.push({ text: t('pos.refundDialog.debit'), value: OrderProductStatus.ReturnedDebitCard.toString() });
            }
            if (p.order.payments.filter(x => x.name === "GiftCard").length > 0) {
                refundMethods.push({ text: t('common.giftCard'), value: OrderProductStatus.ReturnedGiftCard.toString() });
            }
            if (p.paymentsList.filter(x => x.name === "StoreCredit" && (x.status === "Active" || x.status === "1")).length > 0) {
                refundMethods.push({ text: t('pos.refundDialog.storeCredit'), value: OrderProductStatus.ReturnedStoreCredit.toString() });
            }
        }

        return (
            <div>
                <DialogInput
                    title={<DialogHeader text={`${t('pos.refundDialog.applyRefund')} - ${t('common.order')} #` + p.orderId} />}
                    modal={true}
                    open={p.open}
                    autoScrollBodyContent={true}
                    contentStyle={dialogStyle}
                    actions={[
                        <Button
                            key={2}
                            type="CancelButton"
                            name="buttonCancel"
                            className="btn-space"
                            label={t('common.cancel')}
                            onTouchTap={() => this.onClose()} />,
                        <Button
                            key={1}
                            name="addButton"
                            label={t('common.apply')}
                            primary={true}
                            className="btnNewBrandPOS"
                            onTouchTap={() => this.openConfirm()} />
                    ]}>
                    <div>
                        {
                            p.refundNeedManagerApproval ?
                                <div className="row">
                                    <br />
                                    <div className="alert alert-danger">
                                        <p>{t('pos.applyRefundDialog.alertMessage')}</p>
                                    </div>
                                    <h4 className="credential_title">{t('common.credentialsTitle')}</h4>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <TextInput name={`${p.name}Username`}
                                            fullWidth={true}
                                            label={t('common.mgmtTeamUserName')}
                                            floatingLabelText={t('common.mgmtTeamUserName')}
                                            hintText={t('common.mgmtTeamUserName')} />
                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <TextInput name={`${p.name}Password`}
                                            type="password"
                                            fullWidth={true}
                                            label={t('common.mgmtTeamPwd')}
                                            floatingLabelText={t('common.mgmtTeamPwd')}
                                            hintText={t('common.mgmtTeamPwd')}
                                            maxLength={30} />
                                    </div>
                                    <h4 className="mt-1 bold">{t('pos.refundDialog.or')} {t('pos.refundDialog.by')} {t('common.pinCode')}</h4>
                                    <div className="col-lg-12">
                                        <TextInput name={`${p.name}PinCode`} hintText={t('common.password')} fullWidth={true} type="password" maxLength={4} autoComplete="off" />
                                    </div>
                                </div>
                                : ""
                        }
                        {
                            <div className="row">
                                <div className="col-lg-12">
                                    <RadioInput
                                        title={t('pos.refundDialog.refundMethod')}
                                        className="refund-inline-radio-btns"
                                        groupName={`${this.props.name}RefundMethod`}
                                        options={refundMethods}
                                    />
                                </div>
                            </div>
                        }
                        {
                            this.props.returnMethod == OrderProductStatus.ReturnedGiftCard && this.props.monerisGiftCardEnabled && (
                                <div className="row">
                                    <div className="col-lg-12">
                                        <TextInput name={`${this.props.name}GiftCardCvdValue`}
                                            fullWidth={true}
                                            label={t('pos.giftCard.cvdValue.label')}
                                            floatingLabelText={t('pos.giftCard.cvdValue.label')}
                                            hintText={t('pos.giftCard.cvdValue.label')}
                                        />
                                    </div>
                                </div>
                            )
                        }
                        {
                            this.props.returnMethod == OrderProductStatus.ReturnedGiftCard && this.props.paystoneGiftCardEnabled && (
                                <div className="row">
                                    <div className="col-lg-12">
                                        <TextInput name={`${this.props.name}CardNumber`}
                                            fullWidth={true}
                                            label={t('pos.giftCard.pan.label')}
                                            floatingLabelText={t('pos.giftCard.pan.label')}
                                            hintText={t('pos.giftCard.pan.hintText')}
                                        />
                                    </div>
                                </div>
                            )
                        }
                        <div className="row">
                            <h4 className="credential_title purpleText">{"Refundable Products"}</h4>
                            <div className="col-lg-12">
                                <GenericTable
                                    className="pos_refund_table tableHeaderwhiteColorFont"
                                    multiSelectable={false}
                                    enableSelectAll={false}
                                    displaySelectAll={false}
                                    adjustForCheckbox={false}
                                    displayRowCheckbox={false}
                                    selectable={false}
                                    stripedRows={true}
                                    columns={[
                                        { key: "Product", label: t("constants.product") },
                                        { key: "Quantity", label: t("pos.accessorySaleDialog.quantity") },
                                        { key: "Reason", label: t("constants.reason") }
                                      ]}
                                    rows={this.getProducts()}
                                />
                            </div>
                            <div className="col-lg-12">
                                <TextInput
                                    name={`${this.props.name}Notes`}
                                    label={t('common.notes')}
                                    hintText={t('common.notes')}
                                    fullWidth={true}
                                />
                            </div>
                            {
                                this.props.order && this.props.order.shippingCost > 0 && (
                                    <div className="col-lg-12">
                                        <ToggleInput className="refundShipping" name={`${p.name}RefundShipping`} label={t('pos.refundDialog.refundDeliveryShippingCost')} />
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </DialogInput>
                {/* Confirmation Dialog */}

                <DialogInput
                    title={<DialogHeader text={t('pos.productDetails.memberPrice') + " - " + t('common.confirmation')} />}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={t('common.cancel')}
                            onTouchTap={() => this.closeConfirm()} />,
                        <Button
                            key={2}
                            name="buttonRemoveItem"
                            label={t('common.confirm')}
                            primary={true}
                            className="btnNewBrandPOS"
                            onTouchTap={() => this.checkOrderUpdateTime()} />]}
                    modal={true}
                    open={this.state.dialogConfirm}>
                    <strong>{t('pos.refundAmount.confirmRefund')}</strong>
                    <br />
                    <br />
                    <GenericTable
                        className="pos_refund_table tableHeaderwhiteColorFont"
                        multiSelectable={false}
                        enableSelectAll={false}
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        displayRowCheckbox={false}
                        selectable={false}
                        stripedRows={true}
                        columns={[
                            { key: "Product", label: t("constants.product") },
                            { key: "Quantity", label: t("pos.accessorySaleDialog.quantity") },
                            { key: "Reason", label: t("constants.reason") }
                          ]}
                        rows={this.getConfirmationProduct()}
                    />
                </DialogInput>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        model: selectRefundProducts(state, ownProps.name),
        deviceKeyName: state.common.applicationSettings.deviceKeyName,
        saveSuccess: state.form[`${ownProps.name}SaveSuccess`],
        saveError: state.form[`${ownProps.name}SaveError`],
        order: state.entity.posOrder,
        products: (state.entity.posOrder) ? state.entity.posOrder.products : [],
        cashInDrawer: state.entity.cashFlow ? state.entity.cashFlow.cashTotal + state.entity.cashFlow.cashInAmount : 0,
        returnMethod: state.form[`${ownProps.name}RefundMethod`],
        refundAmount: state.form[`POSRefundTotalAmount`],
        picEnabled: state.common.applicationSettings.picEnabled,
        monerisEnabled: state.common.applicationSettings.monerisEnabled,
        payFirmaEnabled: state.common.applicationSettings.payFirmaEnabled,
        paystoneInStoreEnabled: state.common.store.paystoneInStoreEnabled,
        form: state.form,
        pinCode: state.form[`${ownProps.name}PinCode`],
        monerisGiftCardEnabled: state.common.applicationSettings.monerisGiftCardEnabled,
        branchId: state.common.branchId,
        cvdValue: state.form[`${ownProps.name}GiftCardCvdValue`],
        giftCardRefundReponse: state.entity.giftCardRefundReponse || null,
        paystoneGiftCardEnabled: state.common.applicationSettings.paystoneGiftCardEnabled,
        birchmountGiftCardEnabled: state.common.applicationSettings.birchmountGiftCardEnabled,
        cashFlow: state.entity.cashFlow,
        paystoneCardNumber: state.form[`${ownProps.name}CardNumber`],
        paystoneGiftCardRefundTime: state.entity.paystoneGiftCardRefundTime,
        paystoneGiftCardRefundData: state.entity.paystoneGiftCardRefundData,
        birchmountCardNumber: state.form[`${ownProps.name}CardNumber`],
        birchmountGiftCardRefundData: state.entity.birchmountGiftCardRefundData,
        birchmountGiftCardRefundTime: state.entity.birchmountGiftCardRefundTime,
        refundShipping: state.form[`${ownProps.name}RefundShipping`],
        refundNeedManagerApproval: state.common.applicationSettings.refundNeedManagerApproval,
        store: state.common.store,
        posOrderCheckUpateTimeRefundPassed: state.entity.posOrderCheckUpateTimeRefundPassed,
        paymentsList: state.entity.paymentsList
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        formInput: (value, name) => dispatch(formInput(value, name)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        showError: (message) => dispatch(showError(message)),
        formError: (name, error) => dispatch(formError(name, error)),
        addRefund: (orderId, model) => dispatch(addRefundOrder(orderId, model, ownProps.name)),
        cleanForm: () => dispatch(cleanRefundForm(ownProps.name)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        giftCardRefund: (model) => dispatch(giftCardRefund(model)),
        paystoneGiftCardRefund: (model) => dispatch(paystoneGiftCardRefund(model)),
        birchmountGiftCardRefund: (model) => dispatch(birchmountGiftCardRefund(model)),
        checkOrderUpdateTime: (orderId, modifiedDate, updateType) => dispatch(checkOrderUpdateTime(orderId, modifiedDate, updateType))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSRefundDialog))